// export const AUDIO_FORMAT = 'audio/wav'
export const AUDIO_TYPE = 'audio/wav'
export const HISTORY_FORM_SUBMISSION_ERROR_MSG =
  'Error during History Form submission.'
export const RECORDING_START_MESSAGE = 'Recording Started'
export const RECORDING_STOP_MESSAGE = 'Recording Stopped'
export const RECORDING_TRANSCRIPTION = 'Recording is in Transcription'
export const RECORDING_PAUSED = 'Recording is Paused'
export const RECORDING_RESUMED = 'Recording is Resumed'

export const AUDIO_BLOB_NULL_ERROR =
  'Audio blob/file is null. Could not record audio. Please check microphone accessibility settings.'
export const MICROPHONE_ACCESS_ERROR =
  'Error accessing microphone. Please check microphone accessibility settings in browser and system.'
export const INVALID_HEIGHT_FORMAT = 'Please enter a valid height.'
export const INVALID_WEIGHT_FORMAT = 'Please enter a valid weight.'
export const SAVING_PATIENT_DETAILS_MESSGAE =
  'Please Wait. Saving Patient Details.'
export const SPEECH_TO_TEXT_SERVICE_ERROR_MESSAGE =
  'Error occurred while transcribing audio.'
export const FORM_SUBMISSION_ERROR_MESSAGE = 'Error submitting form.'
export const noRelevantDetailsMsg =
  'No relevant details provided in the conversation'

export const toastMessages = {
  FetchSuccess: 'Details fetched successfully',
  SaveSuccess: 'Details saved successfully',
  Errors: 'Error fetching details',
  Form_Submission_Error: 'Failed to Submit the form',
  Form_Updation_Error: 'Failed to Update the form',
  Form_Loading_Error: 'Failed to load the form',
  Fetch_Failed: 'Unable to fetch existing record. Please try again.',
  No_Record_Found:
    'Cannot find existing record to update. Please refresh the page and try again.',
  DoctorFetchError: 'Failed to fetch Doctors',
  InvalidJson: 'Invalid JSON response',
  ParseFailed: 'Failed to parse Id',
  NetworkFailed: 'Trying to connect ... \nPlease check network connectivity.',
  NoRelevantDetailsError: `${noRelevantDetailsMsg}. Please verify the form and restart the recording if required.`,
  ServiceBroken:
    'Oops! Something broke from our end. Please Transcribe again or fill the form manually.',
}

export const successMessages = {
  Form_Submit_Success: 'Form has been submitted successfully',
}

export const specialCharRegExp = /^[A-Za-z0-9 ]+$/
export const invalidChar = 'Invalid Characters'
export const fieldRequiredError = 'This field is required'

export const heightMinCm = 'Height must be at least 1 cm'
export const heightMaxCm = 'Height cannot exceed 300 cm'
export const heightMinFt = 'Height must be at least 1 ft'
export const heightMaxFt = 'Height cannot exceed 10 ft'

export const weightMinKg = 'Weight must be at least 1 kg'
export const weightMaxKg = 'Weight cannot exceed 500 kg'
export const weightMinGm = 'Weight must be at least 1 gm'
export const weightMaxGm = 'Weight cannot exceed 500,000 gm'
export const incorrectSpell = 'cheifComplaints'
export const correctSpell = 'chiefComplaints'

export const heightUnitCm = 'cm'
export const heightUnitFt = 'ft'
export const weightUnitKg = 'kg'
export const weightUnitGm = 'gm'

export const typeOfValue = 'string'

export const getVisitType = (intent: string): string => {
  return (
    [VISIT_TYPES?.DENTAL, VISIT_TYPES?.PHYSIO]?.find((type) =>
      intent?.toLowerCase()?.includes(type)
    ) || VISIT_TYPES?.GENERAL
  )
}

export const reactToken = 'react-token'

export const cleanNoRelevantDetailsMsgConstants = {
  objectStr: 'object',
  stringStr: 'string',
}

export const VISIT_TYPES = {
  DENTAL: 'dental',
  PHYSIO: 'physio',
  GENERAL: 'general',
}

export const LABELS = {
  CYANOSIS: 'Cyanosis',
}

export const HISTORY_TEXT_FIELDS = [
  {
    label: 'Chief Complaint',
    name: 'chiefComplaints',
    placeholder: 'Chief Complaint',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'History Of Present Illness',
    name: 'historyOfPresentIllness',
    placeholder: 'History of Present Illness',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Past History',
    name: 'pastHistory',
    placeholder: 'Past History',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Past Medical History',
    name: 'pastMedicalHistory',
    placeholder: 'Past Medical History',
    validVisitTypes: ['dental'],
  },
  {
    label: 'Other Relevant Habitual History',
    name: 'habitualHistory',
    placeholder: 'Other Relevant Habitual History',
    validVisitTypes: ['general', 'dental'],
  },
  {
    label: 'Obstetric History',
    name: 'obstetricHistory',
    placeholder: 'Obstetric History',
    validVisitTypes: ['general', 'dental'],
  },
  {
    label: 'Family History',
    name: 'familyHistory',
    placeholder: 'Family History',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
]

export const HISTORY_FIELD_KEYS = {
  SCORE: 'wbps',
  HEIGHT: 'height',
  HEIGHT_UNIT: 'heightUnit',
  WEIGHT: 'weight',
  WEIGHT_UNIT: 'weightUnit',
  ENCOUNTER_ID: 'encounterId',
  H_W_TEXT_FIELD_TYPE: 'number',
}

export const HISTORY_TOGGLE_FIELDS = [
  {
    label: 'Wong Baker Pain Score',
    name: HISTORY_FIELD_KEYS.SCORE,
    options: [
      'No Hurt',
      'Hurts Little Bit',
      'Hurts Little More',
      'Hurts Even More',
      'Hurts Whole Lot',
      'Hurts Worst',
    ],
    validVisitTypes: ['general', 'dental'],
  },
  {
    label: 'Diet',
    name: 'diet',
    options: ['Veg', 'Mixed'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Sleep',
    name: 'sleep',
    options: ['Adequate', 'Inadequate'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Bowel & Bladder',
    name: 'bowelBladder',
    options: ['Regular', 'Irregular'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Smoking History',
    name: 'smokingHistory',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Alcoholic History',
    name: 'alcoholicHistory',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'History Of Drug Allergies',
    name: 'historyDrugAllergies',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental'],
  },
  {
    label: 'History Of Previous Surgeries',
    name: 'previousSurgeries',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Pallor',
    name: 'pallor',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Icterus',
    name: 'icterus',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Cyanosis',
    name: 'cyanosis',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Clubbing',
    name: 'clubbing',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Lymphadenopathy',
    name: 'lymphadenopathy',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Edema',
    name: 'edema',
    options: ['Yes', 'No'],
    validVisitTypes: ['general', 'dental', 'physio'],
  },
]

export const HISTORY_FIELD_CORRECTIONS = {
  cheifComplaints: 'chiefComplaints',
}

export const HISTORY_FIELD_OPT = {
  nh: 'nh',
  hlb: 'hlb',
  hlm: 'hlm',
  hem: 'hem',
  hwl: 'hwl',
  hw: 'hw',
}

export const VITALS_TEXT_FIELDS = [
  {
    label: 'Pulse',
    name: 'pulse',
    placeholder: 'Pulse',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Temperature',
    name: 'temperature',
    placeholder: 'Temperature (F)',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Respiratory Rate',
    name: 'respiratoryRate',
    placeholder: 'Respiratory Rate (RR)',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'SPO2',
    name: 'spo2',
    placeholder: 'SPO2',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Systolic BP (mm Hg)',
    name: 'systolic',
    placeholder: 'Systolic BP (mm Hg)',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Diastolic BP (mm Hg)',
    name: 'diastolic',
    placeholder: 'Diastolic BP (mm Hg)',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
]

export const VITALS_TOGGLE_FIELDS = [
  {
    label: 'Posture',
    name: 'posture',
    options: ['Sitting', 'Supine'],
    validVisitTypes: ['general'],
  },
]

export const SYSTEMIC_TEXT_FIELDS = [
  {
    label: 'Local Examination',
    name: 'localExamination',
    placeholder: 'Local Examination',
  },
  {
    label: 'Cardiovascular System',
    name: 'cardiovascularSystem',
    placeholder: 'Cardiovascular System',
  },
  {
    label: 'Respiratory System',
    name: 'respiratorySystem',
    placeholder: 'Respiratory System',
  },
  {
    label: 'Nervous System',
    name: 'nervousSystem',
    placeholder: 'Local Examination',
  },
  {
    label: 'Per Abdomen',
    name: 'perAbdomen',
    placeholder: 'Per Abdomen',
  },
]

export const DIAGNOSIS_TEXT_FIELDS = [
  {
    label: 'Provisional Diagnosis',
    name: 'provisionalDiagnosis',
    placeholder: 'Provisional Diagnosis',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Differential Diagnosis',
    name: 'differentialDiagnosis',
    placeholder: 'Differential Diagnosis',
    validVisitTypes: ['general', 'dental'],
  },
  {
    label: 'Investigations/Diagnostics',
    name: 'investigations',
    placeholder: 'Investigations/Diagnostics',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
  {
    label: 'Final Diagnosis',
    name: 'finalDiagnosis',
    placeholder: 'Final Diagnosis',
    validVisitTypes: ['general', 'dental', 'physio'],
  },
]

export const ASTERISK_CONDITION = {
  provisionalDiagnosis: 'provisionalDiagnosis',
  finalDiagnosis: 'finalDiagnosis',
  physioVisitType: 'physio',
}

export const CLINICAL_TEXT_FIELDS = [
  {
    label: 'Intra Oral Examination',
    name: 'intraOralExamination',
    placeholder: 'Intra Oral Examination',
  },
  {
    label: 'Swelling',
    name: 'swelling',
    placeholder: 'Swelling',
  },
  {
    label: 'Lymphnode Enlargement',
    name: 'lymphnodeEnlargement',
    placeholder: 'Lymphnode Enlargement',
  },
  {
    label: 'Sinus Opening',
    name: 'sinusOpening',
    placeholder: 'Sinus Opening',
  },
]

export const OBJECTIVE_PHYSIO_TEXT_FIELDS = [
  {
    label: 'Posture',
    name: 'posture',
    placeholder: 'Posture',
  },
  {
    label: 'Gait',
    name: 'gait',
    placeholder: 'Gait',
  },
]

export const EXAMINATION_PHYSIO_TEXT_FIELDS = [
  {
    label: 'Palpation',
    name: 'palpation',
    placeholder: 'Palpation',
  },
  {
    label: 'Reflexes',
    name: 'reflexes',
    placeholder: 'Reflexes',
  },
  {
    label: 'ROM',
    name: 'rom',
    placeholder: 'ROM',
  },
  {
    label: 'Muscle Assessment',
    name: 'muscleAssessment',
    placeholder: 'Muscle Assessment',
  },
  {
    label: 'Joint Assessment',
    name: 'jointAssessment',
    placeholder: 'Joint Assessment',
  },
  {
    label: 'Relevant Special Tests',
    name: 'relevantSpecialTests',
    placeholder: 'Relevant Special Tests',
  },
]

export const HISTORY_ANALYSIS_KEYS = {
  CHIEF_COMPLAINTS: 'Chief Complaints',
  HISTORY_OF_PRESENT_ILLNESS: 'History of Present Illness',
  PAST_HISTORY: 'Past History',
  PAST_MEDICAL_HISTORY: 'Past Medical History',
  HABITUAL_HISTORY: 'Other Relevant Habitual History',
  OBSTETRIC_HISTORY: 'Obstetric History',
  FAMILY_HISTORY: 'Family History',
}

export const OPDFORM_ANALYSIS_KEYS = {
  HISTORY_AND_EXAMINATION: 'History & Examination',
  VITALS: 'Vitals',
  SYSTEMIC_EXAMINATION: 'Systemic Examination',
  DIAGNOSIS: 'Diagnosis',
  OBJECTIVE: 'Objective',
  PAIN_HISTORY: 'History',
  TREATMENT_PLAN: 'Treatment plan',
}

export const VITALS_ANALYSIS_KEYS = {
  PULSE: 'Pulse',
  TEMPERATURE: 'Temperature',
  RESPIRATORY_RATE: 'Respiratory Rate',
  SPO2: 'SpO2',
  BLOOD_PRESSURE: 'Blood Pressure',
  POSTURE: 'Posture',
}

export const SYSTEMIC_EXAMINATION_ANALYSIS_KEYS = {
  LOCAL_EXAMINATION: 'Local Examination',
  CARDIO_EXAMINATION: 'Cardiovascular Examination',
  RESPIRATORY_EXAMINATION: 'Respiratory System',
  NERVOUS_SYSTEM: 'Nervous System',
  PER_ABDOMEN: 'Per Abdomen',
}

export const DIAGNOSIS_ANALYSIS_KEYS = {
  PROVISIONAL: 'Provisional',
  DIFFERENTIAL: 'Differential',
  INVESTIGATIONS: 'Investigations(tests)',
  FINAL: 'Final',
}

export const OBJECTIVE_ANALYSIS_KEYS = {
  POSTURE: 'Posture',
  GAIT: 'Gait',
}

export const PAIN_HISTORY_ANALYSIS_KEYS = {
  ONSET: 'Onset, Duration, Variations',
  RELIEVES_PAIN: 'What relieves Pain',
  ACCOMPANYING_SYMPTOMS: 'Accompanying Symptoms',
}

export const CLINICAL_ANALYSIS_KEYS = {
  INTRA_ORAL: 'Intra Oral Examination',
  SWELLING: 'Swelling',
  LYMPHNODE: 'Lymphnode Enlargement',
  SINUS: 'Sinus',
}

export const TREATMENTPLAN_ANALYSIS_KEYS = {
  TREATMENT_PLAN: 'Treatment Plan',
  FOLLOW_UP: 'Follow Up Plan',
  HOME_ADVICE: 'Home Advice',
}

export const EXAMINATION_ANALYSIS_KEYS = {
  PALPATION: 'Palpation',
  REFLEXES: 'Reflexes',
  ROM: 'Range of Motion',
  MUSCLE_ASSESSMENT: 'Muscle Assessment',
  JOINT_ASSESSMENT: 'Joint Assessment',
  RELEVANT_TESTS: 'Relevant Special Tests',
}

export const PAIN_HISTORY_TEXT_FIELDS = [
  {
    label: 'Onset,Duration,Variations',
    name: 'onset',
    placeholder: 'Onset,Duration,Variations',
  },
  {
    label: 'What relieves Pain',
    name: 'whatRelievesPain',
    placeholder: 'What relieves Pain',
  },
  {
    label: 'Accompanying Symptoms',
    name: 'accompanyingSymptoms',
    placeholder: 'Accompanying Symptoms',
  },
]

export const PAIN_HISTORY_TOGGLE_FIELDS = [
  {
    label: 'Pain Constant',
    name: 'painConstant',
    options: ['Yes', 'No'],
  },
  {
    label: 'Sensory Qualities',
    name: 'sensoryQualities',
    options: [
      'Itchy',
      'Hot',
      'Cold',
      'Sharp',
      'Cramping',
      'Gnawing',
      'Hot-burning',
      'Aching',
      'Heavy',
      'Tender',
      'Spliting',
      'Radiating',
    ],
  },
  {
    label: 'Physical Activity',
    name: 'physicalActivity',
    options: ['Yes', 'No'],
  },
  {
    label: 'Concentration',
    name: 'concentration',
    options: ['Yes', 'No'],
  },
]

export const PAIN_HISTORY_NAMES = {
  SelectedNumber: 'selectedNumber',
  SensoryQualities: 'sensoryQualities',
}

export const TREATMENT_PLAN_PHYSIO_TEXT_FIELDS = [
  {
    label: 'Treatment Plan',
    name: 'treatmentPlan',
    placeholder: 'Treatment Plan',
    type: 'textarea',
  },
  {
    label: 'Follow Up Advice',
    name: 'followUpAdvice',
    placeholder: 'Follow Up Advice',
    type: 'textarea',
  },
  {
    label: 'Follow Up Date',
    name: 'followUpDate',
    placeholder: '',
    type: 'date',
  },
  {
    name: 'homeAdvice',
    label: 'Home Advice',
    placeholder: 'Enter home advice',
    type: 'textarea',
  },
  {
    name: 'referralRequired',
    label: 'Referral Required',
    type: 'toggle',
    options: [
      {
        label: 'Yes',
        value: 'yes',
      },
      {
        label: 'No',
        value: 'no',
      },
    ],
  },
]
export const restrictedMicLocations = [
  'medications',
  'lab-orders',
  'radiology-orders',
]
export const TREATMENT_PLAN_TYPES = {
  TOGGLE: 'toggle',
  TEXTAREA: 'textarea',
  DATE: 'date',
  TEXT: 'text',
  SUBMIT: 'submit',
}

export type Doctor = {
  label: string
  value: string
  department: string
}

export const TREATMENT_PLAN_NAMES = {
  DoctorName: 'doctorName',
  Department: 'department',
  ReasonReferral: 'reasonReferral',
}
export const TREATMENT_PLAN_TEXTFIELD_PLACEHOLDERS = {
  Department: 'Enter Department',
  ReasonReferral: 'Enter Reason for Referral',
}

export const REFERRAL_REQUIRED_CONDITION = {
  Yes: 'yes',
  No: 'No',
}

export const FORMIK_VALIDATIONS = {
  Height: 'Height is required',
  Weight: 'Weight is required',
  Pulse: 'Pulse is required',
  Temperature: 'Temperature is required',
  RespiratoryRate: 'Respiratory rate is required',
  SPO2: 'SpO2 is required',
  Systolic: 'Systolic pressure is required',
  Diastolic: 'Diastolic pressure is required',
  Posture: 'Posture is required',

  ProvisionalDiagnosis: 'Provisional Diagnosis is required',
  FinalDiagnosis: 'Final Diagnosis is required',
}

export const PAGE_NAMES = {
  HistoryExamination: 'history',
  Vitals: 'vitals',
  Diagnosis: 'diagnosis',
  Systemic: 'examination',
  TreatmentPlan: 'treatmentplan',
  PainHistory: 'painhistory',
  Objective: 'objective',
}

export const STT_SERVICE_MESSAGES = {
  FileSucess: 'File processed successfully',
  FileError: 'An error occurred while processing the file',
  FhirFetchFailed: 'Failed to fetch FHIR record ID:',
  FetchError: 'An error occurred while fetching the data',
  FileDownloadSucess: 'File download successful.',
}

export const DMS_SERVICE_MESSAGES = {
  FileDownloadSucess: 'File download successful.',
  FileDownloadFailure: 'File download failed.',
}

export const HISTORY_PAIN_SCORE_MAPPING: Record<string, string> = {
  nh: 'No Hurt',
  hlb: 'Hurts Little Bit',
  hlm: 'Hurts Little More',
  hem: 'Hurts Even More',
  hwl: 'Hurts Whole Lot',
  hw: 'Hurts Worst',
}

export const TREATMENT_PLAN_FIELD_NAMES = {
  DoctorName: 'doctorName',
  Department: 'department',
  DisplayName: 'displayName',
  Prefix: 'prefix',
}

export const FORMIK_SUBMISSION_CONST = {
  Submitting: 'Submitting...',
  Submit: 'Submit',
}

export const MIC_FEATURE_CONST = {
  ToolTip_Message: 'Transcribe is enabled only after stopping the recording.',
  recTranscribing: 'Transcribing... Please Wait.',
  recPaused: 'Recording Paused.',
  recInProgress: 'Recording in Progress...',
  recStopped: 'Recording Stopped. Ready to Transcribe.',
}

export const convertBlobToFile = (
  blob: Blob | null,
  fileName: string
): File => {
  if (!blob) {
    throw new Error(AUDIO_BLOB_NULL_ERROR)
  }
  return new File([blob], fileName, { type: AUDIO_TYPE })
}
export const generateFilename = (): string => {
  const now = new Date()

  const istOffset = 5.5 * 60 * 60 * 1000
  const istDate = new Date(now.getTime() + istOffset)

  const year = istDate.getUTCFullYear()
  const month = String(istDate.getUTCMonth() + 1).padStart(2, '0')
  const day = String(istDate.getUTCDate()).padStart(2, '0')
  const hours = String(istDate.getUTCHours()).padStart(2, '0')
  const minutes = String(istDate.getUTCMinutes()).padStart(2, '0')
  const seconds = String(istDate.getUTCSeconds()).padStart(2, '0')
  const milliSeconds = String(istDate.getUTCMilliseconds()).padStart(3, '0')

  return `audio_${year}-${month}-${day}-${hours}-${minutes}-${seconds}-${milliSeconds}`
}

export const capitalize = (word: any) => {
  if (!word || !word.trim() || word == undefined) return ''
  else return word.charAt(0).toUpperCase() + word.slice(1)
}
